import { PureComponent } from 'react'
import _ from 'lodash'
import cx from 'classnames'
import PropTypes from 'prop-types'
import styles from './Image.css'

class Image extends PureComponent {
  constructor () {
    super()
    this.state = {}
    this.fallback = () => {
      if (this.props.fallbackSrc) {
        this.setState({ failed: true })
      }
    }
  }

  render () {
    const { className, src, fallbackSrc } = this.props
    const dataRole = this.props['data-role']
    if (this.state.failed) {
      return (
        <img
          className={className}
          src={fallbackSrc}
          data-role={dataRole}
        />
      )
    } else {
      return (
        <img
          className={className}
          src={src || fallbackSrc}
          onError={this.fallback}
          data-role={dataRole}
        />
      )
    }
  }
}

Image.propTypes = {
  src: PropTypes.string,
  fallbackSrc: PropTypes.string,
  className: PropTypes.string
}

export const ImageBackgroundHolder = props => {
  const { className, url, size, children } = props
  const style = Object.assign(
    {
      backgroundImage: `url(${url})`
    },
    _.isUndefined(size)
      ? {}
      : {
        width: size,
        paddingTop: size
      }
  )
  return (
    <div
      className={cx(styles.ImageBackgroundHolder, className)}
      style={style}
    >
      {children}
    </div>
  )
}

ImageBackgroundHolder.propTypes = {
  url: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string
}

export default Image
